/* KitBeast attribution + sitewide session tracking.
 *
 * Rules (agreed with Gavin / Viktor, 2026-10-11) — do not "improve" without asking, the paid-vs-organic
 * profit split with the client depends on them:
 *   - FIRST TOUCH is the first visit that carries any tracking param (utm_*, gclid/gbraid/wbraid, fbclid).
 *     It is locked for 90 days and never overwritten. A param-less visit never locks anything, and a
 *     later visit never replaces it. This is what the server uses to decide paid vs organic.
 *   - LAST TOUCH (30 days) is replaced only by a visit that carries params; param-less visits never erase it.
 *     Reported for context only, never used for the split.
 *   - fbclid alone is NOT paid (organic FB/IG links carry it too). The server makes the final call.
 * Storage: localStorage + a first-party cookie for the first touch. Safari can cap script-written storage at
 * 7 days, so the session beacon below also stores the first touch server-side (ops app, keyed by visitor id),
 * and /api/lead falls back to that copy if the browser lost it.
 */
(function () {
  var API = 'https://kitbeast-ops-app.vercel.app';
  var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'utm_adgroup', 'matchtype', 'site_source', 'placement', 'gclid', 'gbraid', 'wbraid', 'fbclid'];
  var FIRST = 'kb_attr_first', LAST = 'kb_attr_last', SESS = 'kb_attr_session', LEGACY = 'kb_attr';
  var FIRST_TTL = 90 * 864e5, LAST_TTL = 30 * 864e5;
  var DEBUG = /[?&]kb_debug=1/.test(location.search);
  try { if (DEBUG) sessionStorage.setItem('kb_debug', '1'); else DEBUG = sessionStorage.getItem('kb_debug') === '1'; } catch (e) {}

  function rd(store, k, ttl) { try { var v = JSON.parse(store.getItem(k) || 'null'); if (v && (!ttl || new Date().getTime() - v.ts < ttl)) return v; } catch (e) {} return null; }
  function wr(store, k, v) { try { store.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function cookie(n) { var m = document.cookie.match('(?:^|; )' + n + '=([^;]*)'); return m ? decodeURIComponent(m[1]) : ''; }
  function setCookie(n, v, days) {
    try {
      var host = location.hostname.replace(/^www\./, '');
      document.cookie = n + '=' + encodeURIComponent(v) + ';max-age=' + Math.round(days * 86400) + ';path=/;domain=.' + host + ';SameSite=Lax' + (location.protocol === 'https:' ? ';Secure' : '');
    } catch (e) {}
  }

  var p = new URLSearchParams(location.search), hit = {}, any = false;
  KEYS.forEach(function (k) { var v = p.get(k); if (v) { hit[k] = v.slice(0, 250); any = true; } });
  var base = { landing_page: location.href.slice(0, 1000), referrer: (document.referrer || '').slice(0, 500), ts: new Date().getTime() };

  var first = rd(localStorage, FIRST, FIRST_TTL);
  if (!first) { try { var c = JSON.parse(cookie('kb_ft') || 'null'); if (c && new Date().getTime() - c.ts < FIRST_TTL) first = c; } catch (e) {} }
  if (any) {
    var touch = Object.assign({}, hit, base);
    wr(localStorage, LAST, touch);
    if (!first) { first = touch; wr(localStorage, FIRST, first); setCookie('kb_ft', JSON.stringify(first).slice(0, 3000), 90); }
  }
  if (first && !rd(localStorage, FIRST, FIRST_TTL)) wr(localStorage, FIRST, first); // restore from cookie
  if (!rd(sessionStorage, SESS)) wr(sessionStorage, SESS, base);

  // keep the legacy key the catalogs read in step (same shape: tracking keys + landing_page)
  (function () {
    var l = rd(localStorage, LAST, LAST_TTL); if (!l) return;
    var leg = {}; KEYS.forEach(function (k) { if (l[k]) leg[k] = l[k]; }); leg.landing_page = l.landing_page;
    try { localStorage.setItem(LEGACY, JSON.stringify(leg)); } catch (e) {}
  })();

  function visitorId() {
    try { var v = localStorage.getItem('kb_visitor_id'); if (!v) { v = (crypto.randomUUID ? crypto.randomUUID() : 'v' + new Date().getTime() + Math.random().toString(36).slice(2)); localStorage.setItem('kb_visitor_id', v); } return v; } catch (e) { return ''; }
  }
  function sessionId() {
    try { var s = sessionStorage.getItem('kb_site_sid'); if (!s) { s = (crypto.randomUUID ? crypto.randomUUID() : 's' + new Date().getTime() + Math.random().toString(36).slice(2)); sessionStorage.setItem('kb_site_sid', s); } return s; } catch (e) { return ''; }
  }

  // which sport the visitor has been looking at (from the page address); the contact form sends them into the design kit on it
  function sportOfPath(p) {
    p = String(p || '').toLowerCase();
    if (/basketball/.test(p)) return 'basketball';
    if (/softball|baseball/.test(p)) return 'softball';
    if (/soccer/.test(p)) return 'soccer'; if (/volleyball/.test(p)) return 'volleyball'; if (/lacrosse/.test(p)) return 'lacrosse';
    if (/hockey/.test(p)) return 'hockey'; if (/wrestling/.test(p)) return 'wrestling'; if (/cheer/.test(p)) return 'cheer';
    if (/(girls|womens)/.test(p) && /flag/.test(p)) return 'girlsflag';
    if (/7v7|flag/.test(p)) return 'flag7';
    if (/football|tackle/.test(p)) return 'tackle';
    return '';
  }
  try { var kbSp = sportOfPath(location.pathname + ' ' + location.hash.replace('#', '')); if (kbSp) sessionStorage.setItem('kb_sport', kbSp); } catch (e) {}
  window.kbSport = function () { try { return sessionStorage.getItem('kb_sport') || ''; } catch (e) { return ''; } };

  window.kbGetAttribution = function () {
    var l = rd(localStorage, LAST, LAST_TTL) || {}, f = rd(localStorage, FIRST, FIRST_TTL) || {}, s = rd(sessionStorage, SESS) || {}, o = {};
    KEYS.forEach(function (k) { o[k] = l[k] || ''; o['ft_' + k] = f[k] || ''; });
    o.attr_landing_page = l.landing_page || ''; o.attr_ts = l.ts ? new Date(l.ts).toISOString() : '';
    o.ft_landing_page = f.landing_page || ''; o.ft_referrer = f.referrer || ''; o.ft_ts = f.ts ? new Date(f.ts).toISOString() : '';
    o.session_landing_page = s.landing_page || ''; o.session_referrer = s.referrer || ''; o.page_url = location.href.slice(0, 1000);
    o.fbp = cookie('_fbp'); o.fbc = cookie('_fbc') || (l.fbclid ? 'fb.1.' + l.ts + '.' + l.fbclid : '');
    o.visitor_id = visitorId(); o.session_id = sessionId();
    function cls(g, pre) { var s = (g(pre + 'utm_source') || '').toLowerCase(), m = (g(pre + 'utm_medium') || '').toLowerCase();
      if (g(pre + 'gclid') || g(pre + 'gbraid') || g(pre + 'wbraid') || (s === 'google' && (m === 'cpc' || m === 'paid'))) return 'paid-google';
      if ((m === 'paid_social' && s === 'facebook') || s === 'fb_ad') return 'paid-meta'; return 'organic'; }
    o.attribution_class = cls(function (k) { return o[k]; }, 'ft_'); o.paid_channel = cls(function (k) { return o[k]; }, '');
    return o;
  };
  window.kbNewEventId = function () { return 'kb_' + new Date().getTime() + '_' + Math.random().toString(36).slice(2, 10); };

  var fired = {};
  // A person's first lead conversion is remembered for 30 days (kb_lead_event_id). A design request that follows a
  // contact-form lead fires only its SECONDARY conversion + custom event, so one person is not counted as two primary leads.
  function recentLead() { try { var v = JSON.parse(localStorage.getItem('kb_lead_event_id') || 'null'); return v && new Date().getTime() - v.ts < 30 * 864e5 ? v : null; } catch (e) { return null; } }
  // opts: {eventId, googleSendTo, googleSecondary?, metaCustom?, email?, phone?}. Call ONLY after a confirmed successful submit.
  // Calls that pass googleSecondary (design requests) are "follow-up" calls: primary is skipped if a recent lead exists.
  window.kbTrackLead = function (o) {
    if (!o || !o.eventId || fired[o.eventId]) return; fired[o.eventId] = 1;
    var doneCalled = false, done = function () { if (doneCalled) return; doneCalled = true; try { if (o.onDone) o.onDone(); } catch (e) {} };
    setTimeout(done, 800);   // never hold a visitor longer than this waiting on a tracking request
    var primary = !(o.googleSecondary && recentLead());
    if (DEBUG) { try { console.log('[kb_debug] Lead suppressed', o, 'primary=' + primary, window.kbGetAttribution()); } catch (e) {} done(); return; }
    var secId = o.eventId + '-dr';
    try {
      if (typeof fbq === 'function') {
        if (primary) fbq('track', 'Lead', {}, { eventID: o.eventId });
        if (o.metaCustom) fbq('trackCustom', o.metaCustom, {}, { eventID: secId });
      }
    } catch (e) {}
    try {
      if (typeof gtag === 'function') {
        var ud = {}; if (o.email) ud.email = String(o.email).trim().toLowerCase();
        var d = String(o.phone || '').replace(/\D/g, ''); if (d.length === 10) d = '1' + d; if (d.length >= 11) ud.phone_number = '+' + d;
        if (ud.email || ud.phone_number) gtag('set', 'user_data', ud);
        if (primary && o.googleSendTo) gtag('event', 'conversion', { send_to: o.googleSendTo, transaction_id: o.eventId, event_callback: done });
        if (o.googleSecondary) gtag('event', 'conversion', { send_to: o.googleSecondary, transaction_id: secId });
      }
    } catch (e) {}
    if (!(primary && o.googleSendTo && typeof gtag === 'function')) done();
    if (primary) { try { localStorage.setItem('kb_lead_event_id', JSON.stringify({ id: o.eventId, ts: new Date().getTime() })); } catch (e) {} }
  };

  // ---- one Call / Text button everywhere ----
  // Any link to the site number (tel:+13323170077) opens a small menu: "Call" or "Text". Whichever they pick is logged with
  // this visitor's attribution, and text links get a ref code (first 6 chars of the visitor id) so the text can be traced to
  // this visit. Without JS the link still just calls. The catalogs' own phone sheet is left alone (its buttons are logged).
  var SITE_TEL = '3323170077', SITE_FMT = '332-317-0077';
  window.kbRefCode = function () { return String(visitorId() || '').replace(/-/g, '').slice(0, 6).toLowerCase(); };
  function isSiteTel(a) { var h = a.getAttribute('href') || ''; return /^tel:/i.test(h) && h.replace(/\D/g, '').slice(-10) === SITE_TEL; }
  function closeMenu() { var m = document.getElementById('kb-cs-menu'); if (m && m.parentNode) m.parentNode.removeChild(m); }
  function openMenu(btn) {
    closeMenu();
    if (!document.getElementById('kb-cs-css')) {
      var st = document.createElement('style'); st.id = 'kb-cs-css';
      st.textContent = '#kb-cs-menu{position:absolute;z-index:2147483000;width:260px;max-width:calc(100vw - 16px);background:#fff;color:#0a0a0a;border-radius:14px;box-shadow:0 12px 40px rgba(0,0,0,.28);overflow:hidden;font:700 15px/1.2 Inter,Arial,sans-serif}#kb-cs-menu a{display:flex;align-items:center;gap:10px;padding:15px 18px;color:#0a0a0a;text-decoration:none;background:#fff}#kb-cs-menu a+a{border-top:1px solid #ececec}#kb-cs-menu a:hover,#kb-cs-menu a:focus{background:#f3f7e6;outline:none}#kb-cs-menu span{font-size:18px}';
      document.head.appendChild(st);
    }
    var m = document.createElement('div'); m.id = 'kb-cs-menu'; m.setAttribute('role', 'menu');
    m.innerHTML = '<a data-kb-opt role="menuitem" href="tel:+1' + SITE_TEL + '"><span>\uD83D\uDCDE</span>Call ' + SITE_FMT + '</a><a data-kb-opt role="menuitem" href="sms:+1' + SITE_TEL + '"><span>\uD83D\uDCAC</span>Text ' + SITE_FMT + '</a>';
    document.body.appendChild(m);
    var r = btn.getBoundingClientRect(), sx = window.pageXOffset, sy = window.pageYOffset, w = m.offsetWidth, h = m.offsetHeight;
    var left = Math.max(8, Math.min(r.left + sx, sx + document.documentElement.clientWidth - w - 8));
    var top = (r.bottom + h + 96 > window.innerHeight && r.top > h + 16) ? r.top + sy - h - 8 : r.bottom + sy + 8;   // open above when the button is low on the screen (chat bubbles / bars can cover the bottom)
    m.style.left = left + 'px'; m.style.top = top + 'px';
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });
  document.addEventListener('click', function (e) {
    try {
      var t = e.target, a = t && t.closest ? t.closest('a[href^="tel:"], a[href^="sms:"]') : null;
      if (!a) { if (!(t && t.closest && t.closest('#kb-cs-menu'))) closeMenu(); return; }
      if (a.id === 'videoContactPhone') return;   // the catalogs open their own sheet from this link
      var inSheet = a.closest('.kb-phone-picker, #kb-cs-menu');
      if (!inSheet && isSiteTel(a)) { e.preventDefault(); e.stopPropagation(); openMenu(a); return; }
      var href = a.getAttribute('href') || '', isSms = /^sms:/i.test(href);
      if (isSms && !/ref[\s:#%20-]*[0-9a-f]{6}/i.test(decodeURIComponent(href))) {
        var note = 'Hi KitBeast! (ref ' + window.kbRefCode() + ')', num = href.replace(/^sms:/i, '').split(/[?&]/)[0];
        // '?&body=' is the cross-platform form. It carried the ref code on Gavin's iPhone (2026-10-15 6:55 PM text matched), so keep it.
        a.setAttribute('href', 'sms:' + num + '?&body=' + encodeURIComponent(note));
      }
      if (a.closest('#kb-cs-menu')) setTimeout(closeMenu, 80);
      if (window.Shopify && window.Shopify.designMode) return;
      fetch(API + '/api/site/event', { method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true,
        body: JSON.stringify({ kind: isSms ? 'sms_click' : 'tel_click', visitor_id: visitorId(), session_id: sessionId(), target: href.slice(0, 60), page: location.pathname, attribution: window.kbGetAttribution() }) }).catch(function () {});
    } catch (err) {}
  }, true);

  // ---- sitewide live-session beacon -> ops app "Site Activity" ----
  function beacon(method, extra) {
    try {
      var body = Object.assign({ session_id: sessionId(), visitor_id: visitorId(), page: location.pathname, title: (document.title || '').slice(0, 120) }, extra || {});
      fetch(API + '/api/site/session', { method: method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), keepalive: true }).catch(function () {});
    } catch (e) {}
  }
  // ---- a lead the contact form could not deliver (ops app down / rate limit): the form saved it as kb_lead_pending and let the visitor carry on; retry here, quietly ----
  (function retryPendingLead() {
    try {
      var p = JSON.parse(localStorage.getItem('kb_lead_pending') || 'null'); if (!p || !p.body) return;
      if (p.tries >= 6 || new Date().getTime() - p.ts > 3 * 86400000) { localStorage.removeItem('kb_lead_pending'); return; }
      p.tries = (p.tries || 0) + 1; localStorage.setItem('kb_lead_pending', JSON.stringify(p));
      fetch(API + '/api/lead', { method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true, body: JSON.stringify(p.body) })
        .then(function (r) { return r.json().then(function (j) { return !!(r.ok && j && j.ok); }, function () { return false; }); })
        .then(function (ok) { if (ok) localStorage.removeItem('kb_lead_pending'); }).catch(function () {});
    } catch (e) {}
  })();

  if (!(window.Shopify && window.Shopify.designMode)) {
    beacon('POST', { attribution: window.kbGetAttribution(), referrer: (document.referrer || '').slice(0, 500), user_agent: navigator.userAgent.slice(0, 300), screen: screen.width + 'x' + screen.height });
    setInterval(function () { if (document.visibilityState === 'visible') beacon('PATCH'); }, 30000);
  }
})();
